import * as runtypes from 'runtypes';

export const Config = runtypes.Record({
  verificationID: runtypes.String
});

export type Config = runtypes.Static<typeof Config>;
